import { Paragraph } from 'docx'
import {
  DraftQuestionItem,
  DraftQuestionnaireEntry,
  QuestionSettingCode
} from '../../data/model/questionnaire'
import { isSettingEnabled } from '../questionnaireUtils'
import { SCALE_LABEL_NAMES } from './model'

export const createEntryContentSlider = (
  entry: DraftQuestionnaireEntry
): Paragraph[] => {
  const entryItem = entry.entryItem as DraftQuestionItem
  const paragraphs: Paragraph[] = []

  const { range, labels } = entryItem.questionScale ?? {}
  const { min, max } = range ?? {}

  paragraphs.push(
    new Paragraph({
      text: `Min: ${min}`,
      spacing: {
        before: 200
      }
    }),
    new Paragraph({
      text: `Max: ${max}`,
      spacing: {
        after: 200
      }
    })
  )

  const hasNotApplicable = isSettingEnabled(
    entryItem.settingValues,
    QuestionSettingCode.NotApplicable
  )
  const hasDontKnow = isSettingEnabled(
    entryItem.settingValues,
    QuestionSettingCode.DontKnow
  )

  if (hasNotApplicable || hasDontKnow) {
    const options: Paragraph[] = [
      new Paragraph({ text: 'Default response options:' })
    ]
    let optionNumber = 1

    if (hasNotApplicable) {
      options.push(
        new Paragraph({
          text: `${optionNumber}. Not applicable`,
          spacing: !hasDontKnow ? { after: 200 } : undefined
        })
      )
      optionNumber++
    }

    if (hasDontKnow) {
      options.push(
        new Paragraph({
          text: `${optionNumber}. Don't know`,
          spacing: {
            after: 200
          }
        })
      )
    }

    paragraphs.push(...options)
  }

  // "<name>: <text>" — the parser matches on exactly these names.
  labels?.forEach((label) => {
    const name = SCALE_LABEL_NAMES[label.position]
    const text = label.label.text
    if (name && text) {
      paragraphs.push(new Paragraph(`${name}: ${text}`))
    }
  })

  return paragraphs
}
